// Copyright (c) 2026 WiseTime. All rights reserved.

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "app/store"
import { DialogStatus, WelcomeVideoState } from "./types"

export type { WelcomeVideoState }

const initialState: WelcomeVideoState = {
  lastShownAt: undefined,
  dismissed: undefined, // undefined = not loaded/old user
  dialogStatus: "CLOSED"
}

const welcomeVideoSlice = createSlice({
  name: "welcomeVideo",
  initialState,
  reducers: {
    setWelcomeVideoState: (state, action: PayloadAction<Partial<WelcomeVideoState>>) => {
      if (action.payload.lastShownAt !== undefined) {
        state.lastShownAt = action.payload.lastShownAt
      }
      if (action.payload.dismissed !== undefined) {
        state.dismissed = action.payload.dismissed
      }
      // Always set dialogStatus to CLOSED when loading from storage
      state.dialogStatus = "CLOSED"
    },
    setWelcomeVideoDialogStatus: (state, action: PayloadAction<DialogStatus>) => {
      state.dialogStatus = action.payload
    },
    dismissWelcomeVideo: (state) => {
      // Mark as dismissed so we don't show again during 30-day window
      state.dismissed = true
      state.dialogStatus = "CLOSED"
    },
    updateLastShownAt: (state) => {
      const now = Math.floor(Date.now() / 1000)
      state.lastShownAt = now
    }
  }
})

export const {
  setWelcomeVideoState,
  setWelcomeVideoDialogStatus,
  dismissWelcomeVideo,
  updateLastShownAt
} = welcomeVideoSlice.actions

// Selectors
export const selectWelcomeVideoState = (state: RootState): WelcomeVideoState =>
  state.welcomeVideo

export const selectWelcomeVideoDialogStatus = (state: RootState): DialogStatus =>
  state.welcomeVideo.dialogStatus

export default welcomeVideoSlice.reducer
